import { render } from "./Regist.vue?vue&type=template&id=143e6ef0&scoped=true"
import script from "./Regist.vue?vue&type=script&lang=js"
export * from "./Regist.vue?vue&type=script&lang=js"

import "./Regist.vue?vue&type=style&index=0&id=143e6ef0&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143e6ef0"]])

export default __exports__